{
  "name": "@jspsych-contrib/plugin-spr",
  "version": "0.1.0",
  "description": "Self-paced reading trials using the DOM.",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jspsych-contrib.git",
    "directory": "packages/plugin-spr"
  },
  "author": {
    "name": "jade",
    "url": "https://github.com/jadeddelta"
  },
  "contributors": [
    {
      "name": "Victor Zhang",
      "url": "https://github.com/vzhang03"
    }
  ],
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jspsych-contrib/issues"
  },
  "homepage": "https://github.com/jspsych/jspsych-contrib/tree/main/packages/plugin-spr",
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.0.0",
    "@jspsych/test-utils": "^1.0.0",
    "jspsych": "8.0.0"
  }
}
